import * as React from 'react'
import * as R from 'ramda'
import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody
} from 'react-accessible-accordion'

import { RatingButton, FeedbackAccordionWrapper } from './FeedbackStyles'
import { ContentPage } from './index'

const boxes = (cur, onClick, face = true) =>
  R.times(
    i => (
      <RatingButton
        face={face}
        active={cur === i}
        onClick={() => onClick(i)}
        key={i}
        idx={i}
        autoFocus={i === 4}
      >
        {i + 1}
      </RatingButton>
    ),
    5
  )

function titleClass(rating?: number) {
  return R.isNil(rating) ? 'accordion__title' : 'accordion__title ok'
}

type FeedbackPageProps = {
  page: ContentPage
  pageIdx: number
  setRating: (idx: number, rating: number) => void
  setText: (idx: number, text: string) => void
  setDetailRating: (idx: number, title: string, rating: number) => void
}

type State = {
  textInvalid?: boolean
}

class FeedbackPage extends React.Component<FeedbackPageProps, State> {
  constructor(props: FeedbackPageProps) {
    super(props)
    this.state = { textInvalid: false }
  }
  setTextValid = evt => {
    if (evt.currentTarget.value.trim() === '') {
      this.setState({ textInvalid: true })
    } else {
      this.setState({ textInvalid: false })
    }
  }

  render() {
    const { page, pageIdx, setRating, setText, setDetailRating } = this.props
    const dqs = page.detailedQuestions
    return (
      <FeedbackAccordionWrapper key={pageIdx}>
        <div>
          <h4>
            {dqs.length > 0 && 'A. '}
            {page.title}
          </h4>
          {!page.hideRating && (
            <div style={{ marginBottom: '10px' }}>
              {boxes(page.rating, rating => setRating(pageIdx, rating))}
            </div>
          )}
          <Accordion>
            {dqs.map((dq, idx) => {
              const letter = String.fromCharCode(66 + idx)
              return (
                <AccordionItem key={dq.title}>
                  <AccordionItemTitle
                    className={titleClass(dq.rating)}
                    hideBodyClassName="body-hidden"
                  >
                    <h5 className={dq.rating !== undefined ? 'ok' : ''}>
                      <div className="spacer" />
                      {letter}. {dq.title}
                      <div className="response">
                        {dq.rating !== undefined && (
                          <span>You: {dq.rating + 1}</span>
                        )}
                      </div>
                    </h5>
                  </AccordionItemTitle>
                  <AccordionItemBody>
                    <div className="rating-box">
                      {boxes(
                        dq.rating,
                        rating => setDetailRating(pageIdx, dq.title, rating),
                        false
                      )}
                      <br />
                      <span className="no">Don't agree at all</span>
                      <span className="yes">Fully agree</span>
                    </div>
                  </AccordionItemBody>
                </AccordionItem>
              )
            })}
          </Accordion>
          <textarea
            className={this.state.textInvalid ? 'invalid' : ''}
            onBlur={this.setTextValid}
            placeholder="Please elaborate"
            value={page.text}
            onChange={evt => setText(pageIdx, evt.currentTarget.value)}
          />
        </div>
      </FeedbackAccordionWrapper>
    )
  }
}

export default FeedbackPage



// WEBPACK FOOTER //
// ./src/Components/FeedbackForm/FeedbackPage.tsx